import type { RawParams } from "@uirouter/react";

import Sentry from "@similarweb/sentry-logger";

import { keywordGroupsQueryClient } from "app/services/keyword-groups";
import type { IRouterState, PageViewTrackingHandler } from "single-spa/react-app/router/IRouterState";
import { SwTrack } from "app/services/SwTrack";

export const demandAnalysisSearchTrendsPageViewTracking: PageViewTrackingHandler = async ({ toState, toParams }) => {
    try {
        const { userGroups, sharedGroups } = await keywordGroupsQueryClient.getAllGroups();
        const allKeywordGroups = new Map([...userGroups, ...sharedGroups].map((group) => [group.Id, group]));
        const keywords = toParams.keywordGroup?.length
            ? toParams.keywordGroup.map((keywordGroupId: string) => {
                  return allKeywordGroups.get(keywordGroupId);
              })
            : [];
        const searchTerms = toParams.searchTerm?.length ? toParams.searchTerm.map((term: string) => term.trim()) : [];
        const aiTopics = toParams.aiTopic?.length ? toParams.aiTopic.map((topic: string) => topic.trim()) : [];

        const extraParams = (() => {
            switch (true) {
                case searchTerms.length > 0: {
                    return {
                        KW_list_type: "Search term",
                        KW_list_name:
                            searchTerms.length === 1
                                ? searchTerms[0].trim()
                                : searchTerms.map((term) => term.trim()).join(","),
                        num_of_entities: searchTerms.length,
                        compare_mode: searchTerms.length > 1 ? "on" : "off",
                    };
                }
                case aiTopics.length > 0: {
                    return {
                        KW_list_type: "AI topic",
                        KW_list_name:
                            aiTopics.length === 1
                                ? aiTopics[0].trim()
                                : aiTopics.map((topic) => topic.trim()).join(","),
                        num_of_entities: aiTopics.length,
                        compare_mode: aiTopics.length > 1 ? "on" : "off",
                    };
                }
                default: {
                    return {
                        KW_list_type: "Keyword list",
                        KW_list_name:
                            keywords.length === 1
                                ? keywords[0].Name
                                : keywords.map((keyword) => keyword.Name).join(","),
                        KW_list_num_keywords: keywords.reduce(
                            (acc, keyword) => acc + (keyword.Keywords?.length || 0),
                            0,
                        ),
                        num_of_entities: keywords.length,
                        compare_mode: keywords.length > 1 ? "on" : "off",
                    };
                }
            }
        })();

        SwTrack.trackPageView(toState, { ...toParams, ...extraParams });
    } catch (e) {
        Sentry.error("demandAnalysisSearchTrendsPageViewTracking: unable to track page view", e);
    }
};
